<template lang="pug">
  div.confirm-layout
    div.alert.alert-success
      span 此藥物總存量:  {{ selectedDrugTotalAmount }}
      span.float-right 
    RxCheckBarcode(
      v-if="currentProgress === 'rxCheck'"
      v-on:confirmRx="confirmRx"
    )
    ActionWrap(
      v-if="currentProgress === 'actionWrap'"
      v-on:setActionData="getFetchData"
      :actionProgress="actionProgress"
      :medRecordId="currentSchedule.patient.med_record_number"
      :amount="currentDrug.amount"
      :scheduleId="currentSchedule.id"
      :reviewer="reviewer"
    )

</template>

<script>
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import ActionWrap from './ActionWrap';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';

export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: [
    'confirmProgress', 'actionProgress',
  ],
  data() {
    return {
      reviewer: undefined,
    };
  },
  components: {
    ActionWrap,
    RxCheckBarcode,
  },
  async created() {
    await this.$store.dispatch('getDrugInDevicesWithSameDrug', this.currentDrug.med.id);
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    },
    getFetchData(data) {
      this.$emit('confirmationFinish');
    },
  },
};
</script>




// WEBPACK FOOTER //
// ConfirmFlow.vue?dd4f80bc